import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Calendar } from "@phosphor-icons/react";
import NewsletterOptIn from "@/components/NewsletterOptIn";

export function BlogList() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/public/blog").then(r => setPosts(r.data)); }, []);
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <div className="label-eyebrow">Blog</div>
      <h1 className="font-display text-5xl font-bold tracking-tight mt-3">Approfondimenti dal mondo Real Estate</h1>
      <p className="text-muted-foreground mt-3">Novità, guide e tutorial per professionisti del settore</p>
      <div className="mt-12 space-y-6">
        {posts.length === 0 && <p className="text-muted-foreground text-center py-12">Nessun articolo pubblicato ancora.</p>}
        {posts.map(p => (
          <Link key={p._id} to={`/blog/${p.slug}`} className="kpi-card block hover:border-purple-300" data-testid={`blog-${p.slug}`}>
            {p.cover_image_url && <div className="h-48 -m-6 mb-4 bg-cover bg-center" style={{ backgroundImage: `url(${p.cover_image_url})` }} />}
            <h2 className="font-display text-2xl font-bold tracking-tight">{p.title}</h2>
            {p.subtitle && <p className="text-muted-foreground mt-2">{p.subtitle}</p>}
            <div className="flex items-center gap-3 mt-4 text-xs text-muted-foreground">
              <Calendar size={12} /> {new Date(p.created_at).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}
              {p.author_name && <><span>·</span><span>{p.author_name}</span></>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/public/blog/${slug}`).then(r => setPost(r.data)).catch(() => {}); }, [slug]);
  if (!post) return <div className="max-w-3xl mx-auto px-6 py-16">Caricamento...</div>;
  return (
    <article className="max-w-3xl mx-auto px-6 py-16">
      <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-6"><ArrowLeft size={14} /> Blog</Link>
      {post.cover_image_url && <img src={post.cover_image_url} alt={post.title} className="w-full h-72 object-cover rounded-xl mb-8" />}
      <div className="label-eyebrow">{new Date(post.created_at).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</div>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-3">{post.title}</h1>
      {post.subtitle && <p className="text-xl text-muted-foreground mt-3">{post.subtitle}</p>}
      <div className="mt-8 text-base leading-relaxed whitespace-pre-wrap prose">{post.body}</div>
      {/* Iter207 — Newsletter opt-in in fondo ad ogni articolo del blog */}
      <NewsletterOptIn variant="article" source={`blog:${slug}`} />
    </article>
  );
}
